import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Kullanıcı bilgisi
  const [token, setToken] = useState(localStorage.getItem('token')); // JWT veya session token
  const [loading, setLoading] = useState(true); // Yüklenme durumu

  // Token değiştiğinde veya uygulama yüklendiğinde kullanıcıyı kontrol et
  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
          // Normalde burada token'ı doğrulamak için backend'e bir istek atılır
          // Şimdilik sadece token varsa kullanıcıyı oturum açmış kabul edelim
          const storedUser = JSON.parse(localStorage.getItem('user'));
          setUser(storedUser);
          setToken(storedToken);
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
        // Hata durumunda localStorage'ı temizle
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      } finally {
        // Maksimum 3 saniye sonra loading'i false yap
        setTimeout(() => {
          setLoading(false);
        }, 3000);
      }
    };

    initializeAuth();
  }, []);

  const login = async (username, password) => {
    try {
      // Timeout ile fetch işlemi
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 saniye timeout

      const response = await fetch('https://www.irsaliye.bybello.com/backend/api/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      const data = await response.json(); // Hata durumunda bile JSON parse etmeye çalış

      if (response.ok && data.success) { // response.ok kontrolü eklendi
        setUser(data.user);
        const receivedToken = data.user.id;
        setToken(receivedToken);
        localStorage.setItem('token', receivedToken);
        localStorage.setItem('user', JSON.stringify(data.user));
        return { success: true };
      } else {
        // Backend'den dönen hata mesajını kullan
        return { success: false, error: data.error || 'Giriş başarısız.' };
      }
    } catch (error) {
      console.error('Login sırasında hata:', error);
      if (error.name === 'AbortError') {
        return { success: false, error: 'Bağlantı zaman aşımına uğradı. Lütfen tekrar deneyin.' };
      }
      return { success: false, error: 'Ağ hatası veya sunucu bağlantı sorunu.' };
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
